export default __webpack_public_path__ + "static/media/cork-benefits.eab1b4cf.svg";